import type { PromotionKind } from '@/api/promotions';

export const KNOWN_PROMO_REASONS = [
  'EXPIRED',
  'EXHAUSTED',
  'NOT_STARTED',
  'ALREADY_REDEEMED',
  'NOT_ELIGIBLE',
  'NOT_FOUND',
] as const;

export function promoReasonKey(reason: string | null): string {
  if (reason && (KNOWN_PROMO_REASONS as readonly string[]).includes(reason)) {
    return `promo.reason.${reason}`;
  }
  return 'promo.reason.other';
}

export function promoAppliedKey(kind: PromotionKind): string {
  return `promo.applied.${kind}`;
}
